import { useUser } from '../../contexts/UserContext';
import { Clock, Mail, LogOut } from 'lucide-react';

/**
 * WaitingApproval - Screen shown when user has no role assigned
 * 
 * Displays when:
 * - User exists in auth.users but has no entry in user_roles table
 * - User was deactivated (role removed from metadata)
 * - User is pending admin approval
 */
export default function WaitingApproval() {
  const { user, logout } = useUser();
  
  return (
    <div className="min-h-screen flex items-center justify-center theme-muted px-4">
      <div className="max-w-md w-full p-8 theme-surface rounded-lg shadow-lg text-center border theme-border">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-yellow-500/10 dark:bg-yellow-500/20 rounded-full flex items-center justify-center border border-yellow-500/20">
            <Clock className="w-8 h-8 text-yellow-600 dark:text-yellow-400" />
          </div>
        </div>
        
        <h2 className="text-2xl font-bold theme-text mb-4">
          Waiting for Approval
        </h2>
        
        <p className="theme-text-muted mb-6">
          Your account <span className="font-medium theme-text">{user?.email}</span> has been created but is pending approval from an administrator.
        </p>
        
        <div className="rounded-lg p-4 mb-6 border border-[color-mix(in_srgb,var(--accent-primary) 40%, transparent)] bg-[color-mix(in_srgb,var(--accent-primary) 14%, var(--bg) 86%)]">
          <div className="flex items-start">
            <Mail className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 mr-3 flex-shrink-0" />
            <div className="text-left">
              <p className="text-sm text-blue-700 dark:text-blue-300 font-medium">
                What happens next?
              </p>
              <p className="text-sm text-blue-600 dark:text-blue-400 mt-1">
                You'll receive an email notification once your account is approved. Please check back later or contact an administrator.
              </p>
            </div>
          </div>
        </div>
        
        <button
          onClick={logout}
          className="w-full flex items-center justify-center gap-2 theme-muted theme-text border theme-border py-2 px-4 rounded-md hover:theme-surface transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Sign Out
        </button>
      </div>
    </div>
  );
}
